'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

var _reactBootstrapTypeahead = require('react-bootstrap-typeahead');

require('react-bootstrap-typeahead/css/Typeahead.css');

require('react-bootstrap-typeahead/css/Typeahead-bs4.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DestinationsAutocomplete = function (_React$Component) {
  (0, _inherits3.default)(DestinationsAutocomplete, _React$Component);

  function DestinationsAutocomplete(props) {
    (0, _classCallCheck3.default)(this, DestinationsAutocomplete);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DestinationsAutocomplete.__proto__ || Object.getPrototypeOf(DestinationsAutocomplete)).call(this, props));

    _this.endpoints = {
      autocompleteCities: '/api/cities/autocomplete',
      autocompleteCountries: '/api/countries/autocomplete',
      autocompleteRegions: '/api/regions/autocomplete',
      autocompleteFull: '/api/cities/autocomplete/full',
      autocompleteAirports: '/api/airports/autocomplete'
    };

    _this.settings = {
      endpoint: 'autocompleteCities',
      emptyOnSelect: true,
      multiple: false,
      clearable: false,
      url: process.env.REACT_APP_DESTINATIONS_URL
    };
    _this.ref = React.createRef();

    _this.state = {
      defaultSelected: _this.props.defaultSelected ? _.cloneDeep(_this.props.defaultSelected) : [],
      options: [],
      isLoading: false
    };

    var settings = _this.props.settings;

    if (settings) {
      _this.settings = Object.assign({}, _this.settings, settings);
    }

    _this.request = _this.request.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DestinationsAutocomplete, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderOption = this.props.renderOption;

      return React.createElement(
        'div',
        null,
        React.createElement(_reactBootstrapTypeahead.AsyncTypeahead, {
          id: 'pepe-argento',
          defaultSelected: this.state.defaultSelected,
          options: this.state.options,
          isLoading: this.state.isLoading,
          multiple: this.settings.multiple,
          labelKey: 'name',
          ref: function ref(_ref) {
            return _this2.ref = _ref;
          },
          renderMenuItemChildren: renderOption,
          onChange: function onChange(selected) {
            if (!selected.length && !_this2.settings.multiple) {
              return;
            }

            if (_this2.settings.multiple) {
              _this2.props.onSelected(selected);
            } else {
              var _selected = (0, _slicedToArray3.default)(selected, 1),
                  item = _selected[0];

              _this2.props.onSelected(item);
            }

            if (_this2.settings.emptyOnSelect) {
              _this2.ref.getInstance().clear();
            }
          },
          minLength: 3,
          onSearch: this.request,
          emptyLabel: 'Sin resultados'
        }),
        this.settings.clearable && React.createElement(
          'div',
          { className: 'text-right' },
          React.createElement(
            'a',
            {
              href: 'javascript:void(0)',
              className: 'text-danger',
              onClick: function onClick(e) {
                e.preventDefault();
                _this2.ref.getInstance().clear();
                _this2.props.onEmpty();
              }
            },
            'Vaciar'
          )
        )
      );
    }
  }, {
    key: 'request',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(query) {
        var options, _ref3, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({ isLoading: true });

                options = {
                  method: 'GET',
                  url: '' + this.settings.url + this.endpoints[this.settings.endpoint],
                  params: { query: query }
                };
                _context.next = 4;
                return (0, _axios2.default)(options);

              case 4:
                _ref3 = _context.sent;
                data = _ref3.data;


                this.setState({ options: data, isLoading: false });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x) {
        return _ref2.apply(this, arguments);
      }

      return request;
    }()
  }]);
  return DestinationsAutocomplete;
}(React.Component);

exports.default = DestinationsAutocomplete;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lesamis-react-components/dist/DestinationsAutocomplete.js
// module id = 492
// module chunks = 0